import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import InputWrapper from '../../../components/input-wrapper';

const StateList = ({ country, error, handleChange, inputId, theme, value }) => {
  const { t } = useTranslation();

  const statesList = [
    { item: 'AL', value: 'AL' },
    { item: 'AK', value: 'AK' },
    { item: 'AS', value: 'American Samoa' },
    { item: 'AZ', value: 'AZ' },
    { item: 'AR', value: 'AR' },
    { item: 'AA', value: 'Armed Forces Americas' },
    { item: 'AE', value: 'Armed Forces Europe' },
    { item: 'AP', value: 'Armed Forces Pacific' },
    { item: 'CA', value: 'CA' },
    { item: 'CO', value: 'CO' },
    { item: 'CT', value: 'CT' },
    { item: 'DE', value: 'DE' },
    { item: 'DC', value: 'DC' },
    { item: 'FM', value: 'Federated States Of Micronesia' },
    { item: 'FL', value: 'FL' },
    { item: 'GA', value: 'GA' },
    { item: 'GU', value: 'Guam' },
    { item: 'HI', value: 'HI' },
    { item: 'ID', value: 'ID' },
    { item: 'IL', value: 'IL' },
    { item: 'IN', value: 'IN' },
    { item: 'IA', value: 'IA' },
    { item: 'KS', value: 'KS' },
    { item: 'KY', value: 'KY' },
    { item: 'LA', value: 'LA' },
    { item: 'ME', value: 'ME' },
    { item: 'MH', value: 'Marshall Islands' },
    { item: 'MD', value: 'MD' },
    { item: 'MA', value: 'MA' },
    { item: 'MI', value: 'MI' },
    { item: 'MN', value: 'MN' },
    { item: 'MS', value: 'MS' },
    { item: 'MO', value: 'MO' },
    { item: 'MT', value: 'MT' },
    { item: 'NE', value: 'NE' },
    { item: 'NV', value: 'NV' },
    { item: 'NH', value: 'NH' },
    { item: 'NJ', value: 'NJ' },
    { item: 'NM', value: 'NM' },
    { item: 'NY', value: 'NY' },
    { item: 'NC', value: 'NC' },
    { item: 'ND', value: 'ND' },
    { item: 'MP', value: 'Northern Mariana Islands' },
    { item: 'OH', value: 'OH' },
    { item: 'OK', value: 'OK' },
    { item: 'OR', value: 'OR' },
    { item: 'PW', value: 'PW' },
    { item: 'PA', value: 'PA' },
    { item: 'PR', value: 'Puerto Rico' },
    { item: 'RI', value: 'RI' },
    { item: 'SC', value: 'SC' },
    { item: 'SD', value: 'SD' },
    { item: 'TN', value: 'TN' },
    { item: 'TX', value: 'TX' },
    { item: 'UT', value: 'UT' },
    { item: 'VT', value: 'VT' },
    { item: 'VI', value: 'Virgin Islands' },
    { item: 'VA', value: 'VA' },
    { item: 'WA', value: 'WA' },
    { item: 'WV', value: 'WV' },
    { item: 'WI', value: 'WI' },
    { item: 'WY', value: 'WY' },
  ];

  return (
    <>
      {country === 'US' ? (
        <div className="nf-input-wrapper flex-1">
          <select
            aria-label={t('manual_address.state')}
            autoComplete="new-password"
            className={classNames({
              'has-error': error,
              'is-value': value,
            })}
            id={inputId}
            name={inputId}
            onChange={handleChange}
            style={{ borderColor: theme?.mainColor }}
            value={value}
          >
            <option value=""></option>
            {statesList.map(state => (
              <option key={state.item} value={state.item}>
                {state.value}
              </option>
            ))}
          </select>
          <label htmlFor={inputId}>
            <span className="placeholder" data-testid="placeholder">
              * {t('manual_address.state')}
            </span>
            <span className="placeholder-top" data-testid="placeholder-top" style={{ color: theme?.mainColor }}>
              {t('manual_address.state')}
            </span>
          </label>
          {error && <div className="error">{error}</div>}
        </div>
      ) : (
        <InputWrapper
          classNameInput={classNames({
            'has-error': error,
            'is-value': value,
          })}
          classNameWrapper={classNames({
            'flex-1': true,
          })}
          error={error}
          inputId={inputId}
          onChange={handleChange}
          placeholder={`* ${t('manual_address.province')}`}
          placeholderTop={t('manual_address.province')}
          theme={theme}
          type="text"
          value={value}
        />
      )}
    </>
  );
};

StateList.propTypes = {
  country: PropTypes.string,
  error: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  inputId: PropTypes.string.isRequired,
  theme: PropTypes.oneOfType([PropTypes.object]),
  value: PropTypes.string,
};

export default StateList;
